import { LegalDocumentPage } from "components/LegalDocumentPage";
import {
  disclosuresIntro,
  disclosuresMeta,
  disclosuresSections,
} from "content/disclosuresContent";

export default function DisclosuresPage() {
  return (
    <LegalDocumentPage
      meta={disclosuresMeta}
      intro={disclosuresIntro}
      sections={disclosuresSections}
      helmetDescription="Fortify Portal, Inc. disclosures — who we are, how we operate, and NI 45-110 regulatory information."
    />
  );
}
